import { RootState } from 'store/root-reducer';

export const creditSelector = (state: RootState) => state.credit;
